import { CONTENT_TYPE } from "@educaplay/core";
import BankText from "../BankItems/BankText";
import BankImage from "../BankItems/BankImage";
import BankAudio from "../BankItems/BankAudio";
import BankCard from "../BankItems/BankCard";
import "./MediaBankContent.scss";

const MediaBankContent = ({ data, dashedArray }) => {
  return [...data].map((it, idx) => {
    const dashed = dashedArray === undefined ? false : dashedArray[idx];
    switch (it.type) {
      case CONTENT_TYPE.TEXT:
        return (
          <BankCard dashed={dashed}>
            <BankText text={it.content} dashed={dashed} />
          </BankCard>
        );
      case CONTENT_TYPE.IMAGE:
        return (
          <BankCard dashed={dashed}>
            <BankImage
              text={it.content}
              source={it.src}
              hideText={it.hideText}
              dashed={dashed}
            />
          </BankCard>
        );
      case CONTENT_TYPE.AUDIO:
        return (
          <BankCard dashed={dashed}>
            <BankAudio
              text={it.content}
              source={it.src}
              hideText={it.hideText}
              dashed={dashed}
            />
          </BankCard>
        );
    }
  });
};

export default MediaBankContent;
